export const TOKEN = 'TOKEN'
export const ACTIVE_CAIP_NETWORK_ID = '@appkit/active_caip_network_id'
